import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { MoistureAtmosphericProvider } from 'Context/MoistureAtmospheric';
import { MoistureAtmospheric } from 'Components/RocketDry';
import {
  ViewAtmosphericLogModal,
  ViewMoistureLogModal,
  AddExternalAtmosphericLogModal,
  AddInternalAtmosphericLogModal,
  EditExternalAtmosphericLogModal,
  EditInternalAtmosphericLogModal,
  DeleteExternalAtmosphericLogModal,
  DeleteInternalAtmosphericLogModal,
  AddMoistureLogModal,
  AddMoistureLogReadingModal,
  EditMoistureLogReadingModal,
  // EditMoistureLogGoalModal,
  DeleteMoistureLogModal,
} from 'Containers/RocketDry';

function MoistureAtmosphericWrapper() {
  return (
    <MoistureAtmosphericProvider>
      <MoistureAtmospheric />
      <AddExternalAtmosphericLogModal />
      <AddInternalAtmosphericLogModal />
      <AddMoistureLogModal />
      <AddMoistureLogReadingModal />
      <EditMoistureLogReadingModal />
      <DeleteMoistureLogModal />
      <ViewAtmosphericLogModal />
      <ViewMoistureLogModal />
      <EditExternalAtmosphericLogModal />
      <EditInternalAtmosphericLogModal />
      <DeleteExternalAtmosphericLogModal />
      <DeleteInternalAtmosphericLogModal />
    </MoistureAtmosphericProvider>
  );
}

const MoistureAtmosphericWrapperrMemo = memo(MoistureAtmosphericWrapper, areEqual);

export { MoistureAtmosphericWrapperrMemo as MoistureAtmosphericWrapper };
